import React from "react"

const Quote = ({ children }) => (
  <blockquote className="highlight quote">{children}</blockquote>
)

export default Quote
